module.exports = __webpack_public_path__ + "static/media/wordBountyAlert.902e44c5.PNG";